import {
	styledSystem as ss,
	Box,
} from ".";


export const Flex = ss.styled(Box)``;

Flex.defaultProps = {
	display: "flex",
};